import { use } from "react";
import { AuthContext, AuthContextType } from "./AuthContext";

// See: https://docs.expo.dev/router/advanced/authentication/
// See: https://docs.expo.dev/router/advanced/authentication-rewrites/
// And: https://galaxies.dev/react-native-firebase-authentication-expo-router

// This hook can be used to access the user info.
export function useAuth(expectLoggedIn: boolean = false): AuthContextType {
  const value = use(AuthContext);
  if (!value) {
    throw new Error("useAuth must be wrapped in a <AuthProvider />");
  }
  if (expectLoggedIn) {
    if (!value.isAuthenticated) throw new Error("User not logged in!");
  }

  return value;
}
